import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Photobooth } from './components/Photobooth';
import { Gallery } from './components/Gallery';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-polkadot selection:bg-pink-300 selection:text-pink-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Features data-id="element-4" />
        <Photobooth data-id="element-5" />
        <Gallery data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}